module.exports = __webpack_public_path__ + "static/media/expectancyvalue.87ed51f3.pdf";